import React, { useEffect, useState } from "react";
import JunebaseSplash from "../Splash/JunebaseSplash";
import JunebaseRobot from "./JunebaseRobot";
import FlowArc from "./FlowSequence";
import "./Home.css";

export default function Home() {
  const [visible, setVisible] = useState(false);

  // Runs whenever Home mounts (i.e., when you navigate back to "/")
  useEffect(() => {
    // reset then trigger next frame for replayable animation
    setVisible(false);
    const raf = requestAnimationFrame(() => setVisible(true));
    return () => cancelAnimationFrame(raf);
  }, []);

  return (
    <div>
      <JunebaseSplash
        logoSrc="/logo.png"
        runOncePerSession={false}
        // If splash is showing, it will call this after done — we reset + replay
        onDone={() => {
          setVisible(false);
          requestAnimationFrame(() => setVisible(true));
        }}
      >
        <main className={`jb-home ${visible ? "is-visible" : ""}`}>
          <section className="hero hero-top">
            <p className="hero-problem">Exploring robotics for everyday cooking</p>
            <p className="hero-solution">Version 1 Prototype</p>
          </section>

          <div className="home-block home-robot">
            <JunebaseRobot />
          </div>

          <section className="hero hero-mid">
            <p className="hero-solution">
              We’re exploring a collaborative cooking robot designed to reduce effort
              in everyday cooking, starting with practical and repeatable kitchen tasks.
            </p>
          </section>

          <div className="home-block home-flow">
            <FlowArc />
          </div>
        </main>
      </JunebaseSplash>
    </div>
  );
}